import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, toValue } from "vue";

export function usePageCollection(id: Ref<number> | number) {
  const api = useApi();
  const collectionId = computed(() => toValue(id));

  const query = useQuery({
    queryKey: computed(() => ["admin", "page-collections", collectionId.value]),
    queryFn: () => api.admin.pages.getCollection({ params: { id: collectionId.value } }),
    enabled: computed(() => collectionId.value > 0),
    staleTime: 60 * 1000,
  });

  return {
    collection: computed(() => query.data.value || null),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
